module.exports = __webpack_public_path__ + "static/pdn-documentary.e7664471.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/pdn-documentary.pdf
// module id = 368
// module chunks = 174759553322802